import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectTimeFormat, selectLocale } from "../../store/slices/preferences";

const CLTime = ({ date }) => {
  const locale = useSelector(selectLocale);
  const timeFormat = useSelector(selectTimeFormat); // 12-hour or 24-hour
  const timeObject = new Date(date);
  const formattedTime = timeObject.toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: timeFormat === '12-hour',
  });

  return formattedTime;
};

CLTime.propTypes = {
  date: PropTypes.string.isRequired,
};

export default CLTime;
